"use client";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import Loader from "@/components/Common/Loader";
import Link from "next/link";

const Register = () => {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [registering, setRegistering] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showAdminPassword, setShowAdminPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const router = useRouter();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRegistering(true);
    if (password !== confirmPassword) {
      setError("Password doesn't match.");
      toast.error("Password doesn't match.");
      setRegistering(false)
      return;
    }
    const actualAdminPassword = process.env.NEXT_PUBLIC_ADMIN_PASSWORD;
    if (adminPassword !== actualAdminPassword) {
      setError("Incorrect Admin Password");
      toast.error("Incorrect Admin Password");
      setRegistering(false)
      return;
    }
    setError(null);
    try {
      const response = await fetch("/api/authentication", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          action: "signup",
          fullName
        }),
      });

      if (response.ok) {
        const data = await response.json();
        toast.success("User signed up successfully!");
        setTimeout(() => {
          router.push("/auth/login");
        }, 2000);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Signup failed");
        toast.error(errorData.message || "Signup failed");
      }
    } catch (err) {
      console.log(err);
      toast.error("An error occurred. Please try again.");
    } finally {
      setRegistering(false);
    }
  };

  return (
    <div className="mt-20 flex h-fit w-full flex-col items-center justify-center gap-10 p-20">
      <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-md flex-col gap-6"
      >
        <div className="flex flex-col">
          <label htmlFor="fullName" className="mb-2">
            Full Name
          </label>
          <input
            type="text"
            id="fullName"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="rounded border border-gray-300 p-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="email" className="mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="rounded border border-gray-300 p-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="password" className="mb-2">
            Password
          </label>
          <div className="relative flex w-full flex-col">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded border border-gray-300 p-3"
              required
            />
            <span
              className="absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer"
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </span>
          </div>
        </div>

        <div className="flex flex-col">
          <label htmlFor="confirmPassword" className="mb-2">
            Confirm Password
          </label>
          <div className="relative flex w-full flex-col">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="rounded border border-gray-300 p-3"
              required
            />
            <span
              className="absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer"
              onClick={() => setShowConfirmPassword((p) => !p)}
            >
              {showConfirmPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </span>
          </div>
        </div>

        <div className="flex flex-col">
          <label htmlFor="adminPassword" className="mb-2">
            Admin Password
          </label>
          <div className="relative flex w-full flex-col">
            <input
              type={showAdminPassword ? "text" : "password"}
              id="adminPassword"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className="rounded border border-gray-300 p-3"
              required
            />
            <span
              className="absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer"
              onClick={() => setShowAdminPassword((p) => !p)}
            >
              {showAdminPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </span>
          </div>
        </div>

        {error && <p className="text-xs text-red-500">{error}</p>}

        <button
          type="submit"
          className="rounded-sm bg-primary px-8 py-4 text-base font-semibold text-white transition-all duration-300 ease-in-out  hover:bg-primary/80 dark:bg-primary1 flex justify-center"
          disabled={registering}
        >
          {registering ? <Loader/>: "Sign Up"}
        </button>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Already have an account?{" "}
            <Link href="/auth/login" className="text-primary hover:underline">
              Login
            </Link>
          </p>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Register;
